// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"g8-z"};